<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getGroupLabel()"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flightRouteInput"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">{{ INDRA_getTranslationKey('checkinPerPassenger','title') | ibeadmin:'sync' }}</h2>
			<ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getAllWarnings(flight.idFlight.toString(), ancillaryGroup)">
				<app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'" [classes]="'alert-sidebar top-gap bottom-gap'"
				 [title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
				 + ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">
					<div message><span *ngIf="statusCode !== 46">{{'whatsIncludedSidebars.general.texts.useInAnotherFlight' | ibeadmin:'sync'}}</span>
						<a class="link" href="{{'whatsIncludedSidebars.general.texts.contactLink' | ibeadmin:'sync'}}" target="_blank" [attr.aria-label]="INDRA_getTranslationKey('goRefund','aria') | ibeadmin:'sync'">
							{{'whatsIncludedSidebars.general.texts.contactTap' | ibeadmin:'sync'}}
						</a>
						{{'whatsIncludedSidebars.general.texts.moreInfo' | ibeadmin:'sync'}}
					</div>
				</app-notification>
			</ng-container>
				
			<div *ngFor="let passenger of passengers" class="border sidebar-flight-text">
				<!-- fare related ancillaries for the passenger-->
				<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length > 0" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
							</app-svg>
							<span class="bold">{{INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax)}}</span> 
							{{ INDRA_getTranslationKey('includedIn','text') | ibeadmin:'sync' }} 
							<span class="capitalize">{{INDRA_printBrand()}}.</span>
						</p>
					</div>
				</div>
				<!-- purchased ancillaries for the passenger-->
				<div *ngFor="let item of INDRA_getPurchasedAncillaryForPassenger(passenger.idPax); let i = index;" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p *ngIf="i == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0" class="bold">
							{{INDRA_printPassengerName(passenger)}}
						</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<ng-container *ngIf="!item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
							</ng-container>
							<ng-container *ngIf="item.unconfirmed">
								<app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true"></app-svg>
							</ng-container>
							<span class="bold">{{item.ancillaryDetail}}</span>
							<span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(item.segmentId)}}</span>
						</p>
					</div>
				</div>
				<!-- no ancillaries for the passenger-->
				<div *ngIf="INDRA_getPurchasedAncillaryForPassenger(passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">{{ INDRA_getTranslationKey('notIncluded','text') | ibeadmin:'sync' }}</p>
					</div>
				</div>
			</div>
		</div>
		
		<div class="sidebar-flight-text border">
			<h2 class="title-h2">{{ INDRA_getTranslationKey('handLuggageAllowance','text') | ibeadmin:'sync' }}</h2>
			<div class="sidebar-flight-text no-padding">
				<h5 class="bold  max-weight-dimension">{{ INDRA_getTranslationKey('maxWeightAndDimension','text') | ibeadmin:'sync' }}</h5>
				<p class="">{{ INDRA_getHandBagSpecificWeightLimitTranslationKey('maxWeightPerBag10','text') | ibeadmin:'sync' }}</p>
				<p class="">
					{{ INDRA_getTranslationKey('maxWeightPerBag1','text') | ibeadmin:'sync' }}
				</p>
			</div>
			<!-- <div class="sidebar-flight-text ">
				<h5 class="bold">{{ INDRA_getTranslationKey('maximumDimension','title') | ibeadmin:'sync' }}</h5>
				<p class="">{{ INDRA_getTranslationKey('maximumDimension0','text') | ibeadmin:'sync' }}</p>
			</div> -->
			<div class="sidebar-flight-text ">
				<p>
					{{'whatsIncludedSidebars.detailsHandLuggage.text.oversizeCharge' | ibeadmin:'sync'}}
				</p>
			</div>
			<div class="sidebar-flight-text ">
				<a (click)="INDRA_gotoURL('externalURLs.aboutHandBaggage')" href="javascript:;" class="link extras-feature__link link--external" [attr.aria-label]="INDRA_getTranslationKey('handBaggageRules','aria') | ibeadmin:'sync'">{{ INDRA_getTranslationKey('rulesAndRestrictions','button') | ibeadmin:'sync' }}</a>
			</div>
		</div>
		<div class="sidebar-flight-text" *ngIf="!isBookingView && INDRA_showUpgrade()">
			<p class="muted">{{ INDRA_getTranslationKey('upgrade','text') | ibeadmin:'sync' }}</p>
			<button class="button " (click)="INDRA_upgradeWithCash();" [attr.aria-label]="INDRA_getTranslationKey('dialogeUpgradeToExecutive','aria') | ibeadmin:'sync'">{{INDRA_getTranslationKey('upgradeToExecutive','text') | ibeadmin:'sync'}}</button>
		</div>
		
		<div class="sidebar-flight-text border">
			<p>
				<a class="link extras-feature__link" aria-label="Close dialog" 
					(click)="INDRA_handleClose()" href="javascript:;"
					role="button">
					Close this window
				</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
